import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TIME_PERIOD } from '../models';

@Pipe({
  name: 'timePeriodFormatter',
  pure: false,
})
export class TimePeriodFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: TIME_PERIOD, ...args: any[]): any {
    if (!value) {
      return value;
    }

    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(value: TIME_PERIOD): string {
    return this.translateService.instant(`pipes.time_period.${value}`);
  }
}
